import { supabase } from "@/integrations/supabase/client";
import { loadWelcomePrefs, clearWelcomePrefs } from "./welcomePrefs";
import { replaceMarketAreas, type MarketAreas } from "./renterMarkets";

/**
 * After a user finishes signup, copy the welcome-wizard preferences (which were
 * already being saved into email_captures and localStorage) onto their freshly
 * created profile row, so they don't have to re-enter anything. The areas
 * were picked on this market's site: they replace this market's areas and
 * keep the renter's areas in other markets (Oct 17, renterMarkets.ts).
 */
export const transferWelcomePrefsToProfile = async (userId: string, market?: MarketAreas) => {
  const prefs = loadWelcomePrefs();
  if (!prefs) return;

  const patch: Record<string, unknown> = {};
  if (prefs.preferred_areas?.length) patch.preferred_areas = prefs.preferred_areas;
  if (prefs.preferred_bedrooms != null) patch.preferred_bedrooms = prefs.preferred_bedrooms;
  if (prefs.preferred_budget_min != null) patch.preferred_budget_min = prefs.preferred_budget_min;
  if (prefs.preferred_budget_max != null) patch.preferred_budget_max = prefs.preferred_budget_max;
  if (prefs.preferred_types?.length) patch.preferred_types = prefs.preferred_types;
  if (prefs.preferred_amenities?.length) patch.preferred_amenities = prefs.preferred_amenities;
  if (prefs.move_in_date) patch.move_in_date = prefs.move_in_date;
  if (prefs.move_out_date) patch.move_out_date = prefs.move_out_date;

  if (Object.keys(patch).length === 0) {
    clearWelcomePrefs();
    return;
  }
  if (patch.preferred_areas && market) {
    const { data: row } = await supabase.from("profiles").select("preferred_areas").eq("user_id", userId).maybeSingle();
    patch.preferred_areas = replaceMarketAreas(row?.preferred_areas, prefs.preferred_areas ?? [], market);
  }

  await supabase.from("profiles").update(patch).eq("user_id", userId);
  clearWelcomePrefs();
};
